import { Component, Input } from '@angular/core';
import { LandingConfig } from '../../../../../../domain/landing-config.interface';

// Barra con el logo centrado + hero con la imagen de fondo, título e instrucciones (diseños 3, 4 y 5)
@Component({
  selector: 'app-landing-hero',
  templateUrl: './landing-hero.component.html',
  styleUrls: ['./landing-hero.component.scss'],
})
export class LandingHeroComponent {
  @Input() config: LandingConfig;
}
